import { RiskFormulaType } from './risk-formula-type';
import { BaseEntity } from './base-entity';
import { RiskFactor } from './risk-factor';
import { RiskFormulaStatus } from './risk-formula-status';
import { RiskBand } from './risk-band';
import { EntityType } from './entity-type';
import { EquationPartTypes } from './risk-equation-part-type';

export class RiskFormula extends BaseEntity {
  description: string;
  equation: RiskEquationPart[];
  formulaType?: RiskFormulaType;
  rounding: boolean;
  defaultFormula: boolean;
  formulas?: RiskFormula[];
  factors?: Array<RiskFactor>; // for convenience mocking data
  bands?: Array<RiskBand>; // for convenience mocking data
  status?: RiskFormulaStatus;
  targetType?: EntityType;
  lastUpdateDateString?: string;
}

export class RiskEquationPart {
  order: number;
  label: string;
  type: EquationPartTypes;
  isEdit: boolean;
  factorId: string | number;
}

export class RiskFormulaTestResult {
  impactValue: number;
  probabilityValue: number;
  result: number;
}
